module.exports = __webpack_public_path__ + "img/Sold.fc4220f8.svg";